import { render, staticRenderFns } from "./createPromotion.vue?vue&type=template&id=6ab8be8c&scoped=true"
import script from "./createPromotion.vue?vue&type=script&lang=js"
export * from "./createPromotion.vue?vue&type=script&lang=js"
import style0 from "./createPromotion.vue?vue&type=style&index=0&id=6ab8be8c&prod&lang=css"
import style1 from "./createPromotion.vue?vue&type=style&index=1&id=6ab8be8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab8be8c",
  null
  
)

export default component.exports